import React, { useContext } from 'react';
import { Grid, Typography, Link } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ticketDetailsContext } from '../../TicketDetailsContext';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import { SearchType } from 'helpers/Enums';

let useStyles = makeStyles()(() => ({
    orderLabelText: {
        marginLeft: 8
    }
}));

let BaseInfoOrders = () => {
    let { classes } = useStyles();
    let { formatMessage } = useIntl();
    let service = useContext(ticketDetailsContext);

    return (
        <Grid container>
            <Grid item xs={12}>

                <Typography variant="subtitle2" style={{ color: 'rgb(183, 0, 5)' }}>
                    <b>{formatMessage({ id: LocalizationIds.LinkedOrders }).toUpperCase()}</b>
                </Typography>
            </Grid>
            <Grid item xs={12}>
                {service.selectedOrders.slice(0, 2).map((order, index) =>
                    <React.Fragment key={index}>
                        {order.type === SearchType.WorkOrders &&
                            <>
                                <Link target="_blank" href={`${process.env.REACT_APP_CRM_URL}/spa/WorkOrder/${order.workOrderId}`}>
                                    <Typography variant="body2" display="inline">
                                        {order.workOrderNumber}
                                    </Typography>
                                </Link>
                                <Typography variant="body2" display="inline" className={classes.orderLabelText}>
                                    {order.articleId}&nbsp;{order.articleModel}&nbsp;{order.articleVersion}&nbsp;{order.articleDescription}
                                </Typography>
                            </>
                        }

                        {order.type === SearchType.Orders &&
                            <>
                                <Link target="_blank" href={`${process.env.REACT_APP_CRM_URL}/spa/Order/${order.orderId}`}>
                                    <Typography variant="body2" display="inline">
                                        {order.orderType}{order.orderNumber}
                                    </Typography>
                                </Link>
                                <Typography variant="body2" display="inline" className={classes.orderLabelText}>
                                    {order.orderTitle}
                                </Typography>
                            </>
                        }
                        <br />
                    </React.Fragment>
                )}
                {service.selectedOrders.length > 2 &&
                    <>
                        <Typography variant="caption">{formatMessage({ id: LocalizationIds.OtherLinkedOrdersInTab })} </Typography>
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default BaseInfoOrders;
